import {AxiosError, AxiosResponse} from 'axios';
import {useMutation} from 'react-query';
import postCreateCreditOrderTransaction from './postCreateCashBackOrderTransaction';
import {IPostCreditOrderTransactionPayload} from '../postCreateCreditOrderTransaction/postCreateCreditOrderTransaction';

const usePostCreateCashBackOrderTransaction = (
  handleAfterSuccess?: (response: AxiosResponse<any>) => void,
  handleOnError?: (statusCode: number | null) => void,
) => {
  return useMutation({
    mutationFn: (payload: IPostCreditOrderTransactionPayload) =>
      postCreateCreditOrderTransaction(payload),

    onSuccess: response => {
      handleAfterSuccess?.(response);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      const status = error.response?.status ?? null;
      handleOnError?.(status);
    },
  });
};

export default usePostCreateCashBackOrderTransaction;
